import { useQuery } from '@apollo/client';
import { getContactDataQuery } from '../queries';
import { extractYachtAndContactsFromContactData } from '../transformers';

const getContactData = (actions, itemId) => {
  const queryName = actions.getPublished || actions.get;
  if (!queryName) return null;

  const { loading, error, data: { data = {} } = {} } = useQuery(getContactDataQuery(queryName), {
    fetchPolicy: 'no-cache',
    variables: { id: itemId }
  });
  if (loading || error || !data) return null;

  const yachtAndContacts = extractYachtAndContactsFromContactData(data);
  if (!yachtAndContacts) return null;

  return {
    ...yachtAndContacts,
    image: data.image,
    website: data.website
  };
};

export default getContactData;
